import classNames from 'classnames';
import * as React from 'react';

interface TopToolBoxWrapperProps {
  children: React.ReactNode;
}

export function TopToolBoxWrapper(props: TopToolBoxWrapperProps) {
  const { children } = props;

  const containerRef = React.useRef<HTMLDivElement>(null);
  const contentRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!contentRef.current || !containerRef.current) return;
    const ref = contentRef.current;
    const cRef = containerRef.current;
    const resizeObserver = new ResizeObserver((entries) => {
      /* 为了能让点击在Toolbox两边的时候能触发引擎的选中所以直接设置ml */
      cRef.style.marginLeft = `-${ref.offsetWidth / 2}px`;
    });

    resizeObserver.observe(ref);
    return () => {
      resizeObserver.unobserve(ref);
    };
  }, []);

  return (
    <>
      <div
        ref={containerRef}
        className={classNames('absolute top-2 w-auto flex items-center justify-center left-1/2')}
      >
        <div ref={contentRef}>
          <div className='h-9 border rounded-10px border-FFFFFF0F bg-bgColor17171A pl-[6px] pr-2 flex items-center justify-center'>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
